import { createAction } from 'redux-actions';
export var ADD_PASSENGER = 'ADD_PASSENGER';
export var REMOVE_PASSENGER = 'REMOVE_PASSENGER';
export var SET_PASSENGERS = 'SET_PASSENGERS';
export var UPDATE_PASSENGERS_STATE = 'UPDATE_PASSENGERS_STATE';
export var addPassenger = createAction(ADD_PASSENGER);
export var removePassenger = createAction(REMOVE_PASSENGER);
export var setPassengers = createAction(SET_PASSENGERS, function (passengers) { return passengers; });
export var updatePassengersState = createAction(UPDATE_PASSENGERS_STATE);
